<div class="background">
  <div class="login-container f-d-c">
    <div class="login-title">
      <span class="body-bold-20 center slate-600">{{'general.login' | translate}}</span>
    </div>
    <form class="f-d-c" [formGroup]="form" (ngSubmit)="submit()">
      <div class="form-outline">
        <app-text-input
          id="email"
          name="email"
          type="email"
          [label]="'general.email' | translate"
          [errorMessage]="'errors.invalid_email' | translate"
          [showError]="email.invalid && formSubmitAttempt"
          formControlName="email">
        </app-text-input>
      </div>

      <div class="form-outline">
        <app-text-input
          id="password"
          name="password"
          type="password"
          [enablePasswordToggle]="true"
          [label]="'general.password' | translate"
          [errorMessage]="'errors.invalid_password' | translate"
          [showError]="password.invalid && formSubmitAttempt"
          formControlName="password">
        </app-text-input>
      </div>
      <div class="form-actions">
        <a class="forgot-password blue-500 body-medium-14"
          [routerLink]="['/forgot-password']">{{'general.forgot_password' | translate}}</a>
      </div>
      <div class="login-error" *ngIf="showError || (externalErrorKey && externalErrorKey !== 'email_not_confirmed')">
        <span class="error-text" *ngIf="showError">{{'errors.wrong_email_or_pass' | translate}}</span>
        <span class="error-text" *ngIf="externalErrorKey && externalErrorKey !== 'email_not_confirmed'">
          {{('errors.' + externalErrorKey) | translate}}
        </span>
      </div>

      <div class="form-outline flex center">
        <button type="submit" class="primary-blue-500" id="signin-button" [disabled]="isSubmitting">
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {{'general.continue' | translate}}
        </button>
      </div>

      <div class="login-error login-error--email-confirm" *ngIf="showEmailNotConfirmedError">
        <span class="error-text">{{'errors.email_not_confirmed' | translate}}</span>
        <button type="button" class="primary-blue-500 resend-button" (click)="resendConfirmationEmail()"
          [disabled]="isResendingConfirmation">
          {{'general.resend' | translate}}
        </button>
        <span class="body14 slate-600" *ngIf="resendSuccess">{{'general.confirm_email_sent' | translate}}</span>
        <span class="error-text" *ngIf="resendFailed">{{'errors.resend_confirmation_failed' | translate}}</span>
      </div>

      <div class="social-container">
        <button type="button" class="social-auth-button" (click)="signInWithGoogle()">
          <span class="google-icon"></span>
          <span class="body14">{{'general.google' | translate}}</span>
        </button>
      </div>
    </form>
    <div class="text-center" id="register-hint">
      <span class="caption12 ">{{'general.do_not_have_account' | translate}}</span> <a class="blue-500 body-medium-14"
        [routerLink]="['/sign-up-business']"> &nbsp; {{'general.signup' | translate}}</a>
    </div>
  </div>
</div>
